import React from "react";
import { Modal } from "semantic-ui-react";
import SecondaryBlueButton from "components/Buttons/SecondaryBlueButton";
import ScansCenter from "components/Others/ScansCenter";

const ScansFolderHelpModal = ({ open, scans, close, getAllScansOrdo, removeScanOrdo }) => {
	return (
		<Modal closeIcon open={open} closeOnEscape closeOnDimmerClick onClose={close} size="fullscreen">
			<Modal.Header>Documents scannés</Modal.Header>
			<Modal.Content>
				{(!scans || (Array.isArray(scans) && (scans.length === 0 || scans.map((s) => s.center).length === 0))) && (
					<div>Aucun document scanné dans aucun centre</div>
				)}
				{scans && Array.isArray(scans) && scans.filter((s) => !s.center).length > 0 && (
					<ScansCenter
						key={`no-scansCenter`}
						center={null}
						scans={scans.filter((s) => !s.center)}
						removeScanOrdo={removeScanOrdo}
						getAllScansOrdo={getAllScansOrdo}
					/>
				)}
				{scans &&
					Array.isArray(scans) &&
					[...new Set(scans.filter((s) => !!s.center))].length > 0 &&
					[...new Set(scans?.filter((s) => !!s.center).map((s) => s.center.id))].map((c) => {
						return (
							<ScansCenter
								key={`scansCenter-${c}`}
								center={scans.filter((s) => s.center && s.center.id === c)[0].center}
								scans={scans.filter((s) => s.center && s.center.id === c)}
								removeScanOrdo={removeScanOrdo}
								getAllScansOrdo={getAllScansOrdo}
							/>
						);
					})}
			</Modal.Content>
			<Modal.Actions>
				<SecondaryBlueButton negative onClick={() => close()}>
					Fermer
				</SecondaryBlueButton>
			</Modal.Actions>
		</Modal>
	);
};

export default ScansFolderHelpModal;
